<template>
  <div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-card no-body class="mt-6">
      <el-table
        class="table-responsive table-flush"
        header-row-class-name="thead-light table-th-colorblue table-textcenter"
        :data="projects"
      >
        <el-table-column
          label="Client Name"
          min-width="130px"
          prop="clientName"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-center  name mb-0 text-sm">
              {{ row.clientName }}
            </p>
          </template>
        </el-table-column>

        <el-table-column label="Phone" prop="phone" min-width="120px" sortable>
          <template v-slot="{ row }">
            <p class=" text-center text-sm ">{{ row.phone }}</p>
          </template>
        </el-table-column>

        <el-table-column label="Email ID" prop="emailid" min-width="120px">
          <template v-slot="{ row }">
            <p class="text-center text-sm">{{ row.emailid }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="No. of articles sent"
          prop="articlesent"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <p class="text-center text-sm">{{ row.articlesent }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="No. of articles Read"
          prop="articleread"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <p class="text-center text-sm">{{ row.articleread }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Total Time Spend"
          prop="totaltimespend"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <p class="text-center text-sm">{{ row.totaltimespend }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="No. of article forwarded"
          prop="articleforwarded"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <p class="text-center text-sm">{{ row.articleforwarded }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="No. of Likes"
          prop="likes"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <p class="text-center text-sm">{{ row.likes }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="No. of Comments"
          prop="comments"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <p class="text-center text-sm">{{ row.comments }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="User Community"
          prop="channels"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <p class="text-center text-sm">{{ row.comments }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Date Added"
          prop="dateadded"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <p class="text-center text-sm text-sm">{{ row.dateadded }}</p>
          </template>
        </el-table-column>

        <!-- <el-table-column
        label="Completion"
        prop="completion"
        min-width="240px"
        sortable
      >
        <template v-slot="{ row }">
          <div class="d-flex align-items-center">
            <span class="completion mr-2">%</span>
            <div>
              <base-progress :type="row.statusType" :value="row.completion" />
            </div>
          </div>
        </template>
      </el-table-column> -->
        <!-- <el-table-column min-width="180px">
        <template v-slot="{ row }">
          <el-dropdown trigger="click" class="dropdown">
            <span class="btn btn-sm btn-icon-only text-light">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here</b-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column> -->
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="50"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import projects from "./MISData";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      projects,
      currentPage: 1
    };
  }
};
</script>
